import React from 'react';
import TableRow from '../../../components/common/table-row';
import SimpleDate from '../../../components/common/date';
import { DOC_UPLOAD } from '../../../../src/constants';
import Text from '@dbk/ui-text';


const UploadHistoryListItemHeader = ({ data, statuses }) => {

    let status = '';
    let className = '';

    if (statuses) {
        statuses.map((item, i) => {
            if (item.id === data.status) {
                status = item.text;
            }
        })
    }
    className = DOC_UPLOAD.STATUS_META_DATA[status];

    return (
        <div className="data-container-wrapper">
            <TableRow>
                {/* <TableRow.Column align="center" /> */}
                <TableRow.Column align="left" >
                    <TableRow>
                        <TableRow.Column align="left">
                            <Text size="large" className="headers-font">{data.bpId}</Text>
                        </TableRow.Column>

                        <TableRow.Column align="left">
                            <Text size="large" className="headers-font">{data.contract} </Text>
                        </TableRow.Column>

                        <TableRow.Column align="left">
                            <Text size="large" className="headers-font">{data.userName} </Text>
                        </TableRow.Column>

                        <TableRow.Column  align="left">
                            <Text size="large" className="headers-font">{data.dwoDocName}</Text>
                        </TableRow.Column>

                        <TableRow.Column align="left">
                            <Text className="headers-font" size="large">
                                {data.uploadDate}</Text>
                        </TableRow.Column>

                        <TableRow.Column width={0.5} align="left">
                            <Text className={`headers-font ${className} `} size="large">{status}</Text>
                        </TableRow.Column>
                    </TableRow>
                </TableRow.Column>
            </TableRow>
        </div>
    );
}

export default UploadHistoryListItemHeader;




